import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HomeComponent } from './modules/home/home.component';
import { NavHeaderComponent } from './share/nav-header/nav-header.component';
import { LiffComponent } from './modules/Liff/liff.component';
import { LiffService } from './modules/Liff/liff.service';
import { AuthenticationService } from './core/service/authentication.service';
import { TokenService } from './core/service/token.service';
import { JwtHelperService, JwtModule } from '@auth0/angular-jwt';
import { ReservationComponent } from './modules/reservation/reservation.component';
import { ReservationService } from './modules/reservation/reservation.service';
import { RegisterComponent } from "./modules/register/register.component";
import { RegisterService } from "./modules/register/register.service";
import { CustomerhttpInterceptor } from './core/helper/customerhttp.interceptor';
import { SelectedItemService } from "./core/service/selected-item.service";
import { ValidationService } from "./core/service/validation.service";
import { OptionListService } from './core/service/optionList.service';
// import { DateService } from './core/service/date.service';
import { ErrorDialogComponent } from './share/error-dialog/error-dialog.component';
import { ErrorService } from './core/service/error.service';
import { RequestService } from './core/service/request.service';
import { NbSelectModule } from '@nebular/theme';
import { StarSignDirective } from './share/directive/star-sign.directive';
import { ButtonComponent } from './share/button/button.component';
import { OpenSelectComponent } from './share/component/select/open-select/open-select.component';
import { EnumSelectComponent } from './share/component/select/enum-select/enum-select.component';
import { MessagesModule } from 'primeng/messages';
import { MessageModule } from 'primeng/message';
import { InputTextModule } from 'primeng/inputtext';
import { DropdownModule } from 'primeng/dropdown';
import { DateService } from './core/service/date.service';
import { CommonModule  } from '@angular/common';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { AuthGuard } from './core/_guards';
import { CalendarModule } from 'primeng/calendar';
import { BookComponent } from './modules/book/book.component';
import { BookService } from "./modules/book/book.service";
import { TranhistoryComponent } from './modules/tranhistory/tranhistory.component';
import { TranhistoryService } from "./modules/tranhistory/tranhistory.service";
import { MemberComponent } from './modules/member/member.component';
import { MemberService } from "./modules/member/member.service";
import { BalanceComponent } from './modules/balance/balance.component';
import { BalanceService } from "./modules/balance/balance.service";
import { AccordionModule } from 'primeng/accordion';
import { InputNumberModule } from 'primeng/inputnumber';
import { RippleModule } from 'primeng/ripple';
import { SidebarModule } from 'primeng/sidebar';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { ProgressBarModule } from 'primeng/progressbar';
import { GalleriaModule } from 'primeng/galleria';
import { ScrollTopModule } from 'primeng/scrolltop';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { InputMaskModule } from 'primeng/inputmask';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { FileUploadModule } from 'primeng/fileupload';
import { MessageService } from 'primeng/api';
import { ImageModule } from 'primeng/image';
import { UploadService } from 'src/app/core/service/upload.service';
import { MultiSelectModule } from 'primeng/multiselect';
import { MenubarModule } from 'primeng/menubar';
import { MenuModule } from 'primeng/menu';
import { BadgeModule } from 'primeng/badge';
import { NavFooterComponent } from './share/nav-footer/nav-footer.component';
import { MemberSubComponent } from './modules/memberSub/memberSub.component';
import { MemberSubService } from "./modules/memberSub/memberSub.service";
import { ResSearchComponent } from './modules/resSearch/resSearch.component';
import { ResSearchService } from "./modules/resSearch/resSearch.service";
import { CardModule } from 'primeng/card';
import { SplitterModule } from 'primeng/splitter';
import { PanelMenuModule } from 'primeng/panelmenu';
import { DataViewModule } from 'primeng/dataview';
import { NgxSignaturePadModule } from '@eve-sama/ngx-signature-pad';
import { ScrollerModule } from 'primeng/scroller';
import { CheckboxModule } from 'primeng/checkbox';
import { ConsentFormComponent } from './modules/consentForm/consentForm.component';
import { ConsentFormService } from "./modules/consentForm/consentForm.service";
import { ToggleButtonModule } from 'primeng/togglebutton';

export function tokenGetter() {
  return localStorage.getItem('currentUser');
}

const Component = [
  AppComponent,
  NavHeaderComponent,
  LiffComponent,
  HomeComponent,
  ReservationComponent,
  RegisterComponent,
  BookComponent,
  MemberComponent,
  TranhistoryComponent,
  BalanceComponent,
  NavFooterComponent,
  ErrorDialogComponent,
  MemberSubComponent,
  ResSearchComponent,
  ConsentFormComponent
];

const Service = [
  AuthenticationService,
  TokenService,
  JwtHelperService,
  ErrorService,
  SelectedItemService,
  ValidationService,
  DateService,
  OptionListService,
  UploadService
];

const NB_MODULES = [
  NbSelectModule,
  MessagesModule,
  MessageModule,
  InputTextModule,
  DropdownModule,
  CommonModule,
  CalendarModule,
  AccordionModule,
  InputNumberModule,
  RippleModule,
  SidebarModule,
  TableModule,
  ButtonModule,
  ProgressBarModule,
  GalleriaModule,
  ScrollTopModule,
  ScrollPanelModule,
  InputMaskModule,
  ProgressSpinnerModule,
  FileUploadModule,
  ImageModule,
  MultiSelectModule,
  MenubarModule,
  MenuModule,
  BadgeModule,
  CardModule,
  SplitterModule,
  PanelMenuModule,
  DataViewModule,
  NgxSignaturePadModule,
  ScrollerModule,
  CheckboxModule,
  ToggleButtonModule
];

const Component_Service = [
  LiffService,
  ReservationService,
  RegisterService,
  RequestService,
  BookService,
  MemberService,
  TranhistoryService,
  BalanceService,
  MemberSubService,
  ResSearchService,
  ConsentFormService
];
const Directive = [
  StarSignDirective
];

const Share_Componet = [
  ButtonComponent,
  OpenSelectComponent,
  EnumSelectComponent
];

@NgModule({
  declarations: [
    ...Component,
    ...Directive,
    ...Share_Componet
  ],
  imports: [
    ...NB_MODULES,
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule.forRoot([
      {path: '', component: LiffComponent, pathMatch: 'full'},
      {path: 'register', component: RegisterComponent, pathMatch: 'full'},
      {path: 'reservation', component: ReservationComponent, pathMatch: 'full', canActivate: [AuthGuard]},
      {path: 'book', component: BookComponent, pathMatch: 'full', canActivate: [AuthGuard]},
      {path: 'member', component: MemberComponent, pathMatch: 'full', canActivate: [AuthGuard]},
      {path: 'memberSub', component: MemberSubComponent, pathMatch: 'full', canActivate: [AuthGuard]},
      {path: 'tranhistory', component: TranhistoryComponent, pathMatch: 'full', canActivate: [AuthGuard]},
      {path: 'balance', component: BalanceComponent, pathMatch: 'full', canActivate: [AuthGuard]},
      {path: 'searchRes', component: ResSearchComponent, pathMatch: 'full', canActivate: [AuthGuard]},
      {path: 'consentForm', component: ConsentFormComponent, pathMatch: 'full', canActivate: [AuthGuard]},
    ], { scrollPositionRestoration: 'enabled',useHash: false }),
    JwtModule.forRoot({
      config: {
        tokenGetter: tokenGetter
      }
    })
  ],
  providers: [
    ...Service,
    ...Component_Service,
    MessageService,
    AuthGuard,
    { provide: HTTP_INTERCEPTORS, useClass: CustomerhttpInterceptor, multi: true }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
